import React from "react";
import SupervisorApi from "../../utility/supervisorApi";
import { useQuery } from "@tanstack/react-query";
import { formatDateTime } from "../../components/formatDateTime";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";

function RecentTransaction({ currencyDetails }) {
  const { fetchData } = SupervisorApi();

  const { data } = useQuery({
    queryKey: ["recent"],
    queryFn: () => fetchData("dashboard/recent-transactions"),
  });

  return (
    <div>
      <div className="flex justify-between">
        {" "}
        <h3 className="text-3xl font-semibold mb-2">Recent Transactions</h3>
        {/* <FilterDropdown /> */}
      </div>

      {/* Table */}
      <table className="w-full border-collapse border border-gray-200 rounded-md text-left">
        <thead>
          <tr className="bg-gray-100">
            {["Transaction ID", "Store Name", "Amount", "Date"].map(
              (header) => (
                <th
                  key={header}
                  className=" px-4 py-2 border-b text-center border-gray-300 text-wrap"
                >
                  {header}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={item?.id}>
              <td className="border-b py-2 px-4 text-center text-wrap">
                {item?.transactionID}
              </td>
              <td className="border-b py-2 px-4 text-center justify-center flex items-center gap-2 text-wrap">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: item?.color_code }}
                ></div>

                {item?.storeName}
              </td>

              <td className="border-b py-2 px-4 text-center text-wrap">
                {currencyDetails}
                {formatNumbersWithDecimal(item?.amount)}
              </td>
              {/* <td className="border-b py-2 px-4 text-center text-wrap">
                {item?.recentTransaction[0]?.orderdetails[0]?.unit_price}
              </td> */}
              <td className="border-b py-2 px-4 text-center text-wrap">
                {formatDateTime(item?.createdAt)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RecentTransaction;
